module.exports = __webpack_public_path__ + "c27a7b6c3ce817287312c11f8c0eed61.jpg";